import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StatsProvider } from "@/context/StatsContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Library from "@/pages/Library";
import AddSong from "@/pages/AddSong";
import SongDetail from "@/pages/SongDetail";
import EditSong from "@/pages/EditSong";
import Practice from "@/pages/Practice";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import Billing from "@/pages/Billing";
import HowItWorks from "@/pages/HowItWorks";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-muted-foreground" data-testid="protected-loading">Loading…</div>;
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  return children;
}

function AppShell() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/library" element={<Protected><Library /></Protected>} />
          <Route path="/songs/new" element={<Protected><AddSong /></Protected>} />
          <Route path="/songs/:id" element={<Protected><SongDetail /></Protected>} />
          <Route path="/songs/:id/edit" element={<Protected><EditSong /></Protected>} />
          <Route path="/songs/:id/practice" element={<Protected><Practice /></Protected>} />
          <Route path="/billing" element={<Protected><Billing /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <StatsProvider>
            <AppShell />
            <CookieBanner />
            <Toaster position="top-center" richColors />
          </StatsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
